// Presentation facade for Journey Lab full-flow control. `journey-language` owns mode vocabulary; this
// module retains only the control-state labels and tones.

import type { JourneyLiveArmMode, JourneyLiveControlState } from './journey-live-api.ts';
import { journeyLiveModePresentation } from './journey-language.ts';
import type { Tone } from './primitives.tsx';

export function journeyLiveModeLabel(mode: JourneyLiveArmMode): string {
  return journeyLiveModePresentation(mode).label;
}

export function journeyLiveModeName(mode: JourneyLiveArmMode): string {
  return journeyLiveModePresentation(mode).name;
}

export function journeyLiveModeProofBoundary(mode: JourneyLiveArmMode): string {
  return journeyLiveModePresentation(mode).proofBoundary;
}

export function journeyLiveControlTone(state: JourneyLiveControlState): Tone {
  if (state === 'armed') return 'attention';
  if (state === 'stopped') return 'blocked';
  return 'neutral';
}

export function journeyLiveControlLabel(state: JourneyLiveControlState): string {
  if (state === 'armed') return 'Armed';
  if (state === 'stopped') return 'Stopped';
  return 'Disarmed';
}
